!function() {
  "use strict";

  const selectors = {
    scale: "[data-ticker-scale]",
    text: "[data-ticker-text]",
  };
  const attributes = {
    clone: "data-clone",
    autoplay: "autoplay",
    speed: "speed",
  };
  const classes = {
    animated: "ticker--animated",
    unloaded: "ticker--unloaded",
    comparitor: "ticker__comparitor",
  };
  const defaultSpeed = 1.63;
  const animationDivisor = 100;

  if (customElements.get("ticker-bar")) return;

  customElements.define("ticker-bar", class extends HTMLElement {
    constructor() {
      super();
      this.autoplay = this.hasAttribute(attributes.autoplay);
      this.scale = this.querySelector(selectors.scale);
      this.text = this.querySelector(selectors.text);
      this.speed = this.hasAttribute(attributes.speed) ? this.getAttribute(attributes.speed) : defaultSpeed;
      this.comparitor = this.text.cloneNode(true);
      this.comparitor.classList.add(classes.comparitor);
      this.appendChild(this.comparitor);
      this.scale.classList.remove(classes.unloaded);
      this.checkWidthEvent = this.checkWidth.bind(this);
    }

    connectedCallback() {
      requestAnimationFrame(() => this.checkWidth());

      this.addEventListener("theme:ticker:refresh", debounce(() => this.checkWidthEvent(), 50));
      screen.orientation.addEventListener("change", this.checkWidthEvent);
      document.addEventListener("theme:resize:width", this.checkWidthEvent);
    }

    disconnectedCallback() {
      document.removeEventListener("theme:resize:width", this.checkWidthEvent);
    }

    checkWidth() {
      this.text = this.querySelector(selectors.text);
      if (!this.text || !this.scale || !this.comparitor) return;

      const paddingLeft = parseFloat(window.getComputedStyle(this).paddingLeft) || 0;
      const horizontalPadding = paddingLeft * 2;
      const scaleWidth = this.clientWidth - horizontalPadding;
      const comparitorWidth = this.comparitor.clientWidth;
      const textWidth = this.text.clientWidth;
      const needsClone = scaleWidth < comparitorWidth;
      const cloneCount = this.autoplay
        ? Math.max(2, Math.floor((window.innerWidth - horizontalPadding) / textWidth))
        : 2;
      const animationTime = ((textWidth / animationDivisor) * Number(this.speed)).toFixed(2);

      if (needsClone || this.autoplay) {
        this.text.classList.remove(classes.animated);
        this.scale.querySelectorAll(`[${attributes.clone}]`)?.forEach((node) => node.remove());

        if (this.autoplay || needsClone) {
          for (let index = 0; index <= cloneCount; index++) {
            const clone = this.text.cloneNode(true);
            clone.setAttribute(attributes.clone, "");
            this.scale.appendChild(clone);
          }
        }

        this.scale.style.setProperty("--animation-time", `${animationTime}s`);
        this.scale.querySelectorAll(selectors.text)?.forEach((node) => {
          node.classList.add(classes.animated);
        });
      } else {
        this.text.classList.add(classes.animated);
        this.scale.querySelectorAll(`[${attributes.clone}]`).forEach((node) => {
          node.parentNode.removeChild(node);
        });
        this.text.classList.remove(classes.animated);
      }
    }
  });

  function debounce(callback, wait) {
    let timeout;

    return function() {
      if (!callback) return;

      const invoke = () => callback.apply(this, arguments);
      clearTimeout(timeout);
      timeout = setTimeout(invoke, wait);
    };
  }
}();
